import { FormGroupInput, NovaSelect, NovaClose, Card, DropDown, Button } from "../components/index";

const GlobalComponents = {
  install(Vue) {
    Vue.component("fg-input", FormGroupInput);
    Vue.component("nova-select", NovaSelect);
    Vue.component("nova-close", NovaClose);
    Vue.component("drop-down", DropDown);
    Vue.component("card", Card);
    Vue.component("p-button", Button);
  }
};

export default GlobalComponents;